<template>
    <div>
        <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            :hideCategory="true"
        >
        </TopAppBar>
        <div class="mdc-drawer-app-content mdc-top-app-bar--fixed-adjust">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
/**
 * 다이나믹 링크 메인 컴포넌트(Dynamic Link main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../mixins/topAppBar.js'

export default {
    name: 'dynamic',
    data() {
        return {
            // title
            title: 'Dynamic Link'
        }
    },
    components: {
        TopAppBar
    },

    mixins: [topAppBarMixin],
    mounted() {

    },
    methods: {

    }
}
</script>
